import {  useState } from 'react';
import {obtenerActividades,obtenerActividadesFechaTodas,
    actualizarActividadFecha,ingresarActividadFecha,eliminarActividadFecha,obtenerSerie,
    actualizarActividadFechaSerie,eliminarActividadFechaSerie} from '../data/Agenda';
import {obtenerUsuariosSistemaPorFiltro} from '../data/UsuarioSistema';
import { useContext } from "react";
import { AuthContext } from "auth";
import moment from 'moment';
import 'moment/locale/es';

export const useAgenda= () => {
    var {user}= useContext(AuthContext);
    const [actividades,setActividades]=useState();
    const [actividadesFecha,setActividadesFecha]=useState({});
    const [events, setEvents] = useState([]);
    const [eventsTypes,setEventsTypes]=useState([])
    const [opcionesSelectorTrabajadoras,setTrabajadorasSelector]=useState([])
    const [respuestaActualizarActividadFecha, setRespuestaActualizarActividadFecha] = useState({mensajeTexto:"",estado:false});
    
    const getActividades= async() => {
        const respuesta=await obtenerActividades(user.Token);
        setActividades(respuesta);
        let opcionesSelector=[];
        respuesta?.map((elem)=>{
              opcionesSelector.push(
                  {
                      value:elem.Valor,
                      label:elem.Nombre,
                      index:elem.Valor
                  }
              )
        });
        setEventsTypes(opcionesSelector);
    }
    
    const getActividadesFecha=async(fecha,usuarioAgenda)=>{
        const respuesta=await obtenerActividadesFechaTodas(fecha,usuarioAgenda,user.Token);
        setActividadesFecha(respuesta);
        var eventos=[];  
        respuesta?.forEach((e) =>  {
            e.Fecha=e.Fecha.substring(0,19);
            e.FechaTermino=e.FechaTermino.substring(0,19);
        
            eventos.push({
            title:e.Asunto==null?e.ActividadTerapeuticaNombre:e.Asunto,
            start: moment(e.Fecha).toDate(),
            end:  moment(e.FechaTermino).toDate(),
            id:e.Id,
            desc:'-',
            tipoactividadid:e.ActividadTerapeuticaId,
            detalle:e.Detalle,
            tipoactividadnombre:e.ActividadTerapeuticaNombre,
            origen:e.Origen,
            status:e.Estado,
            horaInicio:e.HoraInicio,
            horafin:e.HoraFin,
            tipoevento:e.TipoEvento,
            participantes:e.Participantes,
            serieid:e.SerieId
        })
    }); 
        console.log(JSON.stringify(eventos))
        setEvents(eventos)
    }
    const updateActividadFecha=async(ActividadFechaPorActualizar,usuarioSistema,usuarioAgenda)=>{
        if(ActividadFechaPorActualizar!=null){
            const objetoActualizar={
                Id:ActividadFechaPorActualizar.id,
                Fecha:ActividadFechaPorActualizar.start,
                FechaTermino:ActividadFechaPorActualizar.end,
                Asunto:ActividadFechaPorActualizar.title,
                Detalle:ActividadFechaPorActualizar.detalle,
                ActividadTerapeuticaId:ActividadFechaPorActualizar.tipoactividadid,
                Usuario:usuarioSistema,
                Participantes:ActividadFechaPorActualizar.participantes,
                UsuarioAgenda:usuarioAgenda
                

            }
            const respuesta=await actualizarActividadFecha(objetoActualizar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarActividadFecha({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarActividadFecha({estado:false,mensajeTexto:respuesta.message})
            }
            return respuesta;
        }
    }
    const deleteActividadFecha=async(ActividadFechaPorActualizar,UsuarioSistema)=>{
        if(ActividadFechaPorActualizar!=null){
            const objetoActualizar={
                Id:ActividadFechaPorActualizar.id,
                Usuario:UsuarioSistema,
                Origen:ActividadFechaPorActualizar.origen,
                PotencialId:ActividadFechaPorActualizar.potencialid,
                Fecha:ActividadFechaPorActualizar.start,
                FechaTermino:ActividadFechaPorActualizar.end
            }
            console.log(JSON.stringify(ActividadFechaPorActualizar))
            const respuesta=await eliminarActividadFecha(objetoActualizar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarActividadFecha({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarActividadFecha({estado:false,mensajeTexto:"Se produjo un error"})
            }
            return respuesta;
        }
    }
    
    const insertActividadFecha=async(ActividadFechaPorIngresar,UsuarioSistema,usuarioAgenda)=>{
       
        if(ActividadFechaPorIngresar!=null){
            
            const objetoIngresar={
                ActividadTerapeuticaId:ActividadFechaPorIngresar.tipoactividadid,
                Fecha:ActividadFechaPorIngresar.start,
                FechaTermino:ActividadFechaPorIngresar.end,
                Asunto:ActividadFechaPorIngresar.title,
                Detalle:ActividadFechaPorIngresar.detalle,
                Usuario:UsuarioSistema,
                Estado:'OK',
                TipoEvento:ActividadFechaPorIngresar.tipoevento,
                Participantes:ActividadFechaPorIngresar.participantes,
                Dia:ActividadFechaPorIngresar.dia,
                Frecuencia:ActividadFechaPorIngresar.frecuencia,
                HoraInicio:ActividadFechaPorIngresar.horainicio,
                HoraFin:ActividadFechaPorIngresar.horafin,
                FechaInicioSerie:ActividadFechaPorIngresar.seriestart,
                FechaFinSerie:ActividadFechaPorIngresar.serieend,
                UsuarioAgenda:usuarioAgenda

            }
            const respuesta=await ingresarActividadFecha(objetoIngresar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarActividadFecha({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarActividadFecha({estado:false,mensajeTexto:respuesta?.message})
            }
            
            return respuesta;
        }
    }
    
    //Serie
    const deleteActividadFechaSerie=async(ActividadFechaPorActualizar,UsuarioSistema)=>{
        console.log('deleteActividadFechaSerie')
        console.log(JSON.stringify(ActividadFechaPorActualizar))
        if(ActividadFechaPorActualizar!=null){
            const objetoActualizar={
                Id:ActividadFechaPorActualizar.id,
                Usuario:UsuarioSistema
            }
            //console.log(JSON.stringify(ActividadFechaPorActualizar))
            const respuesta=await eliminarActividadFechaSerie(objetoActualizar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarActividadFecha({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarActividadFecha({estado:false,mensajeTexto:"Se produjo un error"})
            }
            return respuesta;
        }
    }

    const updateActividadFechaSerie=async(ActividadFechaPorActualizar,UsuarioSistema,UsuarioAgenda)=>{
        if(ActividadFechaPorActualizar!=null){
            const objetoActualizar={
                Id:ActividadFechaPorActualizar.id,
               
                FechaInicioSerie:ActividadFechaPorActualizar.seriestart,
                FechaFinSerie:ActividadFechaPorActualizar.serieend,
                Asunto:ActividadFechaPorActualizar.title,
                Detalle:ActividadFechaPorActualizar.detalle,
                ActividadTerapeuticaId:ActividadFechaPorActualizar.tipoactividadid,
                Usuario:UsuarioSistema,
                Dia:ActividadFechaPorActualizar.dia,
                Frecuencia:ActividadFechaPorActualizar.frecuencia,
                HoraInicio:ActividadFechaPorActualizar.horainicio,
                HoraFin:ActividadFechaPorActualizar.horafin,
                //Participantes:ActividadFechaPorActualizar.participantes,
                UsuarioAgenda:UsuarioAgenda

            }
            console.warn('updateActividadFechaSerie')
            console.log(JSON.stringify(objetoActualizar))
            const respuesta=await actualizarActividadFechaSerie(objetoActualizar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarActividadFecha({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarActividadFecha({estado:false,mensajeTexto:respuesta?.message})
            }
            return respuesta;
        }
    }
       
    const getTrabajadoras= async() => {
       
        const respuesta=await obtenerUsuariosSistemaPorFiltro('',user.Token);
        //setActividades(respuesta);
        let opcionesSelector=[];
        //console.log(JSON.stringify(respuesta));
        respuesta?.map((elem)=>{

                //console.log(JSON.stringify(elem));
                  opcionesSelector.push(
                      {
                          value:elem.Usuario,
                          label:elem.NombreSocial,
                          index:elem.Usuario
                      }
                  )
            });
            setTrabajadorasSelector(opcionesSelector);
    }
     
    const getSerie= async(serieId) => {
        console.log('getSerie'+serieId)
        const respuesta=await obtenerSerie(serieId,user.Token);
        
        const serie={
       
        title:respuesta.Asunto,
        tipoactividadid: respuesta.ActividadTerapeuticaId,
        tipoevento: 2,
        detalle:respuesta.Detalle,
        dia:respuesta.Dia,
        frecuencia:respuesta.Frecuencia,
        horainicio:respuesta.HoraInicio,
        horafin:respuesta.HoraFin,
        seriestart:moment(respuesta.FechaInicioSerie).toDate(),
        serieend:moment(respuesta.FechaFinSerie).toDate(),
        participantes:respuesta.Participantes,
        estado:'OK',
        id:respuesta.Id

       
        };
       
        return serie;
        
    }
    
  
    return {
        actividades,
        getActividades,
        actividadesFecha,
        getActividadesFecha,
        updateActividadFecha,
        insertActividadFecha,
        deleteActividadFecha,

        updateActividadFechaSerie,
        deleteActividadFechaSerie,

        events,
        eventsTypes,
        respuestaActualizarActividadFecha,
        setRespuestaActualizarActividadFecha,
        getTrabajadoras,
        opcionesSelectorTrabajadoras,

        getSerie,
        //serieEditando
        
        
    }
}
